import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import { css } from "./Theme";
import Box from "./Box";
import Flex from "./Flex";
import Button from "./Button";
import useKey from "../hooks/useKey";
import useDocumentState from "../hooks/useDocumentState";
const {
  useEffect
} = React;

const CanvasHeader = props => {
  const scaleUp = useKey("=");
  const scaleDown = useKey("-");
  const [scale, setScale] = useDocumentState("scale");
  const [showEditor, setShowEditor] = useDocumentState("showEditor");
  const showEditorText = showEditor ? "Hide" : "Show";
  useEffect(() => {
    if (scaleUp) {
      setScale(scale + 10);
    } else if (scaleDown) {
      setScale(scale - 10);
    }
  }, [scaleUp, scaleDown]);
  const headerStyles = css({
    backgroundColor: "background.primary",
    borderBottom: "1px solid",
    borderColor: "background.tertiary",
    fontSize: 1,
    color: "font.secondary",
    width: "100%",
    // boxShadow: "2px 0 5px rgba(0,0,0,.1)",
    zIndex: "2",
    justifyContent: "space-between"
  });
  return ___EmotionJSX(Flex, {
    css: headerStyles
  }, ___EmotionJSX(Flex, {
    css: css({
      width: "100%",
      justifyContent: "right",
      px: 4,
      py: 3
    })
  }, ___EmotionJSX(Box, null), ___EmotionJSX(Flex, {
    css: css({
      alignItems: "center",
      pr: 4
    })
  }, ___EmotionJSX(Box, {
    css: css({
      mr: 3
    })
  }, scale && `${scale}%`), ___EmotionJSX(Button, {
    active: scaleDown,
    css: css({
      mr: 2
    }),
    onClick: () => setScale(scale - 10)
  }, "-"), ___EmotionJSX(Button, {
    active: scaleUp,
    onClick: () => setScale(scale + 10)
  }, "+")), ___EmotionJSX(Flex, null, ___EmotionJSX(Button, {
    onClick: () => setShowEditor(!showEditor)
  }, showEditorText, " Panel"))));
};

export default CanvasHeader;